/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/

import React from 'react';
import { Navigate } from "react-router-dom";
import Cookies from 'js-cookie';

interface LoginGuardedRouteProps {
	children: React.ReactChild,
}
const LoginGuardedRoute: React.FC<LoginGuardedRouteProps> = (props: any) => {
	const { children } = props;

	if (Cookies.get('auth') != undefined && Cookies.get('auth') == 'true') {
		return <Navigate key="applicationPath" to={"/applications"} />;
	}

	return children;
};

export default LoginGuardedRoute;